import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ComingSoon from "../comingSoon/comingSoon";

import recordImg from "../../assets/images/noRecord.svg";
import "./tableHistory.css";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    borderBottom: "0 !important",
  },
}));

const options = ["add", "remove"];

const ITEM_HEIGHT = 48;

const TableHistory = ({ title, desc, tableHeader, rows, titleNoRecord, descNoRecord }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="historyTable">
      <Box
        className="tableHeader"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ width: "90%" }}>
          <Typography variant="h6">{title}</Typography>
          <Typography>{desc}</Typography>
        </Box>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              selected={option === "remove"}
              onClick={handleClose}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 420 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {tableHeader.map((header, key) => (
                <StyledTableCell align="center" key={key}>
                  {header}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ?
              <StyledTableRow>
                <StyledTableCell colSpan={tableHeader.length}>
                  <ComingSoon
                    title={titleNoRecord}
                    desc={descNoRecord}
                    img={recordImg}
                  />
                </StyledTableCell>
              </StyledTableRow>
              : <>
                {rows.map((row, key) => (
                  <StyledTableRow key={key}>
                    {tableHeader.map((column, key) => (
                      <StyledTableCell align="center" key={key}>
                        {row?.[column]}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}</>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableHistory;
